/**
 * Created by Rodrigo Quesada on 09/05/17.
 */
import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {Model} from '../../../../domain/model/common/model.class';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {FileListService} from '../../../../components/files/service/file-list.service';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import {ActivityLogsService} from '../../../../domain/model/work/activity-logs/activity-logs.service';
import {ActivityLogs} from '../../../../domain/model/work/activity-logs/activity-logs.model';
import ProjectionInformation = Model.ProjectionInformation;

@Component({
    template: require('./activity-logs-screen.component.html')
})
export class ActivityLogsScreenComponent {

    constructor(readonly modelService: ActivityLogsService,
                readonly route: ActivatedRoute,
                readonly fileListService: FileListService,
                readonly fileLocationFactory: FileLocationFactory) {

        this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<ActivityLogs>({
        initialDataModel: new ActivityLogs(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: ActivityLogs) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    fileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('activityLogs', 'currentUser', new ProjectionInformation('file'))
    });

    fileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('activityLogs', 'currentUser', new ProjectionInformation('files'))
    });

    get model(): ActivityLogs {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    private _refreshFilesInfo() {
        this.fileListService.list(this.fileUploaderModel.filesLocation).subscribe(files => this.fileListModel.files = files);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/activity-logs/activity-logs-screen.component.ts